import React, {useEffect, useState} from 'react';
import {Dialog, DialogContent, DialogTitle, IconButton, Skeleton, Tooltip} from "@mui/material";
import BBIconQuickViewMagnifying from "../../../assets/bbCustomIcons/BBIconQuickViewMagnifying";
import {Col, Row} from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";
import BBDataTable from "../tables/BBDataTable";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import {fetchCloudIntegrationFiles} from "../../../actions";
import {useDispatch, useSelector} from "react-redux";
import BBIconCheck from "../../../assets/bbCustomIcons/BBIconCheck";
import BBIconRoundedDashNull from "../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import BBIconExclamationTriangleError from "../../../assets/bbCustomIcons/BBIconExclamationTriangleError";

const ExpandCloudIntegrationStorageFiles = ({storageName = null, hasFiles=false, integrationId=null}) =>{

    const {entityInView, portfolios, cloudIntegrations, loadingCloudIntegrations, loadingCloudIntegrationsError, loadingCloudIntegrationData, loadingCloudIntegrationDataError} = useSelector(({breachrisk}) => breachrisk);

    const [open, setOpen] = useState(false)

    const dispatch = useDispatch();

    // const testFiles=[
    //     {
    //         "name": "azure.png",
    //         "url": "https://adlabuploads.s3.amazonaws.com/azure.png",
    //         "type": "image/png",
    //         "public": false
    //     },
    //     {
    //         "name": "win10lab.vhd",
    //         "url": "https://adlabuploads.s3.amazonaws.com/win10lab.vhd",
    //         "type": "text/x-vhdl",
    //         "public": false
    //     }
    // ]

    const cloudIntegrationObjects = cloudIntegrations
        && cloudIntegrations[entityInView]
        && cloudIntegrations[entityInView].integrations;
    const cloudIntegrationData = cloudIntegrations
        && cloudIntegrations[entityInView]
        && cloudIntegrations[entityInView].integrations
        && cloudIntegrations[entityInView].integrationData;

    const hasError = loadingCloudIntegrationDataError
        && loadingCloudIntegrationDataError[entityInView]
        && loadingCloudIntegrationDataError[entityInView].files
        && loadingCloudIntegrationDataError[entityInView].files[`${integrationId}-${storageName}`]
        && loadingCloudIntegrationDataError[entityInView].files[`${integrationId}-${storageName}`].hasError

    // const hasError = false;
    const cloudIntegrationFiles = !hasError
    && cloudIntegrationData
    && cloudIntegrationData.files
        ? cloudIntegrationData.files
        : null;
    const filesObjForStorageName = !hasError
    && cloudIntegrationFiles
    && Object.values(cloudIntegrationFiles)
    && Object.values(cloudIntegrationFiles).find(x => x.name === storageName)
        ? Object.values(cloudIntegrationFiles).find(x => x.name === storageName)
        : null;
    const files = !hasError
    && filesObjForStorageName
    && filesObjForStorageName.files
        ? filesObjForStorageName.files
        : [];
    // const files=testFiles;
    const userMessage = hasError
        && loadingCloudIntegrationDataError[entityInView].files[`${integrationId}-${storageName}`].userMessage

    useEffect(()=>{
        if(hasFiles
            && open
            && files.length < 1
            && !loadingCloudIntegrationData[entityInView].files
            && !hasError){
            dispatch(fetchCloudIntegrationFiles(entityInView, integrationId, storageName));
        }
    }, [open, hasFiles, files])

    const tableData = hasFiles && files && files.length > 0 && files.map((file, index)=>{
        return{
            ...file,
            id: `${file.name}_${index}`,
        }
    })

    // console.log("hasError", hasError,"usermessage" ,userMessage,"FIles", files, "cloudIntegragionFiles", cloudIntegrationFiles, "filesObjForStorageName", filesObjForStorageName, "CloudIntegrationData", cloudIntegrationData, "storageName", storageName, "integrationId", integrationId, "cloudIntegrationObjects", cloudIntegrationObjects, "loadingCloudIntegrationdata",loadingCloudIntegrationData ,"loadingCloudIntegrationDataError", loadingCloudIntegrationDataError)

    const columns = [
        { field: `name`, headerName: 'File', hide: false, flex: 1, type: 'string',
            renderCell: (params)=>
                renderCellExpand(params, <p className={"align-self-center"}> {params.value ? params.value : "  "}</p>)},

        { field: `type`, headerName: 'Type', hide: false, flex: 1, type: 'string',
            renderCell: (params)=>
                renderCellExpand(params, <p> {params.value ? params.value : "  "}</p>)},
        { field: `url`, headerName: 'URL', hide: false, flex: 1.5, type: 'string',
            renderCell: (params)=>
                renderCellExpand(params, <p> {params.value ? params.value : "  "}</p>)},
        { field: `public`, headerName: 'Public', hide: false, flex: .5, type: 'string',
            renderCell: (params)=>
                renderCellExpand(params, <p> {params.value ? <BBIconCheck/> : <BBIconRoundedDashNull/>}</p>)},
    ]

    return(
        <span>
            <Tooltip title={"View a list of files associated with this resource."}>
                <IconButton
                    // disabled={!hasFiles}
                    onClick={()=> setOpen(true)}
                >
                    <BBIconQuickViewMagnifying/>
                </IconButton>
            </Tooltip>

            {open &&
                <Dialog open={open}
                        fullScreen={false}
                        fullWidth={true}
                        maxWidth={"md"}
                        className={"m-1 p-1 animated fadeIn animation-duration-7"}
                        aria-labelledby="form-dialog-title">

                    <DialogTitle id="customized-dialog-title" >
                        <Row>
                            <Col lg={11}/>
                            <Col lg={1} className={"text-right align-self-center d-print-none"}>
                                <IconButton
                                    onClick={()=>setOpen(false)}
                                    className={"close"}>
                                    <CloseIcon/>
                                </IconButton>
                            </Col>
                        </Row>
                    </DialogTitle>

                    <DialogContent>
                        <Row className={"text-center"}>
                            <Col>
                                <h1>Files for {storageName && storageName}</h1>
                            </Col>
                        </Row>
                        {(loadingCloudIntegrationData
                            && loadingCloudIntegrationData[entityInView]
                            && loadingCloudIntegrationData[entityInView].files)
                            ? <Row className={"mx-1 px-1 text-center"}>
                                <Col>
                                    <p>Number of Private Files: <Skeleton/></p>
                                </Col>
                                <Col>
                                    <p>Number of Public Files: <Skeleton/></p>
                                </Col>
                            </Row>
                        :<Row className={"mx-1 px-1 text-center"}>
                                <Col>
                                    <p>Number of Private Files: {filesObjForStorageName && filesObjForStorageName.number_of_files ? filesObjForStorageName.number_of_files  : "--"}</p>
                                </Col>
                                <Col>
                                    <p>Number of Public Files: {filesObjForStorageName && filesObjForStorageName.number_of_files_public ? filesObjForStorageName.number_of_files_public : "--"}</p>
                                </Col>
                            </Row>}
                        {!hasError && !(loadingCloudIntegrationData
                            && loadingCloudIntegrationData[entityInView]
                            && loadingCloudIntegrationData[entityInView].files)
                            ? <BBDataTable rows={tableData}
                                         columns={columns}
                                         progressValue={100}
                                           disableColumnSelector={true}
                                           disableDensitySelector={true}
                                         disableColumnMenu={true}
                                     />
                            :hasError
                                ?<div className={"m-5 p-5 border-1 border-gray text-center"}>
                                    <h1 className={"text-red"}><BBIconExclamationTriangleError style={{fontSize:"75px"}}/></h1>
                                    <h3 className={"text-red"}>{userMessage}</h3>
                                </div>
                                :<BBDataTable rows={[]}
                                          columns={columns}
                                              loading = {true}
                                              progressValue={0}
                                              bufferValue={15}
                                          disableColumnSelector={true}
                                          disableDensitySelector={true}
                                          disableColumnMenu={true}
                            />
                        }
                    </DialogContent>

            </Dialog>}
        </span>

    )
}

export default ExpandCloudIntegrationStorageFiles;
